export class DashCred {
    usereid: string;
    orgcode: string;
}
